<template>
    <span id="qpe-tooltip">
        <v-tooltip 
            v-if="!is_disable_vuetify_tooltip"
            content-class="tooltip"    
            open-delay="1000"
            :top="tooltip_position === 'top'"
            :right="tooltip_position === 'right'"
            :bottom="tooltip_position === 'bottom'"
            :left="tooltip_position === 'left'"
        >
            <template #activator="{ on, attrs }">
                <span
                    v-bind="attrs"
                    v-on="on"
                >
                    <slot 
                        name="hovered_item"
                    />
                </span>
            </template>
            <slot
                name="tooltip_content"
            />
        </v-tooltip>

        <template v-else>
            <span 
                class="tooltip--self-made"
                @mouseover="is_show_self_made_tooltip = true"
                @mouseleave="is_show_self_made_tooltip = false"
            >
                <slot 
                    name="hovered_item"
                />
            </span>
        </template>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'QpeTooltip',
        
        props: {
            tooltip_position: {
                type: String,
                default() {
                    return 'bottom'
                }
            }
        },

        data() {
            return {
                is_show_self_made_tooltip: false
            }
        },

        computed: {
            ...mapGetters([
                'is_mobile_width',
                'is_pad_width',
            ]),

            is_disable_vuetify_tooltip() {
                return this.is_mobile_width || this.is_pad_width
            }
        },
    }
</script>

<style lang="scss" scoped>
    .tooltip {
        margin-top: 1rem;
        padding: .25rem .5rem;
        font-size: 12px;
        font-family: NotoSansCJKtc;
        letter-spacing: .5px;
        line-height: 1.33;
        color: #131415;
        background: #fff;
        border-radius: 4px;
        opacity: .92 !important;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .24);

        &__content {
            &--self-made {
                position: absolute;

                .left {
                    transform: translate(-200%, 0);
                }

                .bottom {
                    transform: translate(-100%, 0);
                }
            }
        }
    }
</style>